export function chooseWritingCompanionMomentV1(projects, canWrite) {
  if (!canWrite) return { kind: "reader", project: null };

  const rows = Array.isArray(projects) ? projects : [];
  const published = new Set([
    "published", "publishedamazon", "published_amazon",
    "publishedexternal", "published_external", "externallypublished",
  ]);

  const valid = rows.filter((project) => {
    if (!project || typeof project !== "object") return false;
    const id = String(
      project.projectId || project.legacyStoryId || project.id || project._id || ""
    ).trim();
    return Boolean(id);
  });

  const eligible = valid.filter((project) => {
    const status = String(
      project?.lifecycle?.publicationStatus || project.publicationStatus || ""
    ).trim().toLowerCase();
    return !published.has(status);
  });

  if (eligible.length === 0) {
    return { kind: valid.length ? "revisit" : "start", project: null };
  }

  const time = (project) => {
    const date = Date.parse(String(project.updatedAt || ""));
    return Number.isFinite(date) ? date : 0;
  };
  const latest = eligible.slice().sort((a, b) => time(b) - time(a))[0];
  return { kind: "resume", project: latest };
}
